// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Full Container width */

.Dropdown_fullDropdown__6LYLC {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    border: 1px solid var(--color-lightui-surface-4);
    border-radius: 4px;
    box-shadow: none;
    font-size: 14px;
    line-height: 21px;
    padding: 1px 8px;
    height: 2rem;
}

.Dropdown_fullDropdown__6LYLC:focus-within {
    outline: 2px solid var(--color-primary);
    outline-offset: -1px;
}

.Dropdown_disabled__x-MEQ {
    background-color: var(--color-lightui-surface-3) !important;
    color: var(--color-darkui-accent-2);
}

.Dropdown_disabledItem__WCifc {
    pointer-events: none;
    opacity: 0.5;
}

.Dropdown_fullDropdownToggle__AelQ5 {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
}

.Dropdown_fullDropdownIcon__YvaBm {
    display: inline-block;
    padding-top: 5px;
}

/** Stationary DropDown **/
.Dropdown_dropdown__ioXBM {
    display: flex;
    width: fit-content;
    align-items: center;
    cursor: pointer;
    position: relative;
    border: 1px solid var(--color-lightui-surface-4);
    border-radius: 4px;
    box-shadow: none;
    font-size: 14px;
    line-height: 21px;
    padding: 1px 8px;
    height: 2rem;
}

.Dropdown_dropdown__ioXBM:focus-within {
    outline: 2px solid var(--color-primary);
    outline-offset: -2px;
}

.Dropdown_dropdownToggle__t8jni {
    display: flex;
    align-items: center;
    gap: 8px;
}

.Dropdown_dropdownMenu__OC6Uw {
    font-size: 14px;
    background: white;
    border-radius: 5px;
    padding: 0;
    margin: 2px 0 0 -1px;
    list-style: none;
    position: absolute;
    top: 100%;
    left: 0;
    overflow: auto;
    transition: all 0.2s ease-out;
    max-height: 0;
    box-shadow: 0 2px 5px var(--color-137), inset 0px 0px 0px 1px var(--color-103);
}

.Dropdown_open__9YFXq .Dropdown_dropdownMenu__OC6Uw {
    max-height: 100vh;
    padding: 5px 0;
}

.Dropdown_dropdownMenu__OC6Uw .Dropdown_divider__uMAti {
    margin: 4px 0;
    border: 0;
    background-color: var(--color-103);
    height: 1px;
    cursor: initial;
}

.Dropdown_dropdownMenu__OC6Uw li {
    position: relative;
    font-size: 14px;
    line-height: 14px;
}

.Dropdown_dropdownMenu__OC6Uw li * {
    box-sizing: content-box;
}

.Dropdown_dataDiv__Qp8Xc {
    display: flex;
    align-items: center;
    padding: 4px 0px;
    white-space: nowrap;
    color: var(--color-text-dark);
    text-decoration: none;
}

.Dropdown_dropdownMenu__OC6Uw li .Dropdown_dataDiv__Qp8Xc svg {
    padding: 3px 2px;
    font-size: 12px;
    display: inline;
    visibility: hidden;
}

.Dropdown_dropdownMenu__OC6Uw .Dropdown_active__TP6Xj .Dropdown_dataDiv__Qp8Xc svg {
    visibility: visible;
}

.Dropdown_dropdownMenu__OC6Uw li .Dropdown_dataDiv__Qp8Xc span {
    padding: 0 14px 0 0;
    white-space: nowrap;
}

.Dropdown_dropdownMenu__OC6Uw li .Dropdown_dataDiv__Qp8Xc:hover {
    color: white;
    background-color: var(--color-primary);
    background-image: none;
    background-repeat: no-repeat;
    text-decoration: none;
}

.Dropdown_dropdownMenu__OC6Uw .Dropdown_indent__tTYBn {
    margin-left: 14px;
}

.Dropdown_dropdownMenu__OC6Uw .Dropdown_checkmark__QChGb {
    display: inline-block;
    width: 14px;
    height: 14px;
    padding: 0 4px;
    margin-top: -6px;
}

.Dropdown_dropdownIcon__gxUNe {
    display: inline-block;
}

.Dropdown_dropdownIconPiece__eR5dU {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    min-width: 10px;
    line-height: 0;
}

.Dropdown_dropdownInput__dGygC {
    display: flex;
    width: 100%;
}

.Dropdown_dropdownInput__dGygC input {
    border: none;
    width: 100%;
    padding: 0;
}

.Dropdown_highlightedText__eWmbw {
    text-decoration: underline;
}

.Dropdown_itemDescription__fMbY6 {
    margin-left: 16px;
    font-style: italic;
}

.Dropdown_error__k9ivW {
    outline: 2px solid var(--color-red-dark-1);
    outline-offset: -1px;
}

.Dropdown_itemOverflowContainer__of7oZ {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Dropdown/Dropdown.module.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gDAAgD;IAChD,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,oBAAoB;AACxB;;AAEA;IACI,2DAA2D;IAC3D,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gDAAgD;IAChD,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,cAAc;IACd,6BAA6B;IAC7B,aAAa;IACb,8EAA8E;AAClF;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kCAAkC;IAClC,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,sCAAsC;IACtC,sBAAsB;IACtB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":["/** Full Container width */\n\n.fullDropdown {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n    border: 1px solid var(--color-lightui-surface-4);\n    border-radius: 4px;\n    box-shadow: none;\n    font-size: 14px;\n    line-height: 21px;\n    padding: 1px 8px;\n    height: 2rem;\n}\n\n.fullDropdown:focus-within {\n    outline: 2px solid var(--color-primary);\n    outline-offset: -1px;\n}\n\n.disabled {\n    background-color: var(--color-lightui-surface-3) !important;\n    color: var(--color-darkui-accent-2);\n}\n\n.disabledItem {\n    pointer-events: none;\n    opacity: 0.5;\n}\n\n.fullDropdownToggle {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n}\n\n.fullDropdownIcon {\n    display: inline-block;\n    padding-top: 5px;\n}\n\n/** Stationary DropDown **/\n.dropdown {\n    display: flex;\n    width: fit-content;\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n    border: 1px solid var(--color-lightui-surface-4);\n    border-radius: 4px;\n    box-shadow: none;\n    font-size: 14px;\n    line-height: 21px;\n    padding: 1px 8px;\n    height: 2rem;\n}\n\n.dropdown:focus-within {\n    outline: 2px solid var(--color-primary);\n    outline-offset: -2px;\n}\n\n.dropdownToggle {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.dropdownMenu {\n    font-size: 14px;\n    background: white;\n    border-radius: 5px;\n    padding: 0;\n    margin: 2px 0 0 -1px;\n    list-style: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    overflow: auto;\n    transition: all 0.2s ease-out;\n    max-height: 0;\n    box-shadow: 0 2px 5px var(--color-137), inset 0px 0px 0px 1px var(--color-103);\n}\n\n.open .dropdownMenu {\n    max-height: 100vh;\n    padding: 5px 0;\n}\n\n.dropdownMenu .divider {\n    margin: 4px 0;\n    border: 0;\n    background-color: var(--color-103);\n    height: 1px;\n    cursor: initial;\n}\n\n.dropdownMenu li {\n    position: relative;\n    font-size: 14px;\n    line-height: 14px;\n}\n\n.dropdownMenu li * {\n    box-sizing: content-box;\n}\n\n.dataDiv {\n    display: flex;\n    align-items: center;\n    padding: 4px 0px;\n    white-space: nowrap;\n    color: var(--color-text-dark);\n    text-decoration: none;\n}\n\n.dropdownMenu li .dataDiv svg {\n    padding: 3px 2px;\n    font-size: 12px;\n    display: inline;\n    visibility: hidden;\n}\n\n.dropdownMenu .active .dataDiv svg {\n    visibility: visible;\n}\n\n.dropdownMenu li .dataDiv span {\n    padding: 0 14px 0 0;\n    white-space: nowrap;\n}\n\n.dropdownMenu li .dataDiv:hover {\n    color: white;\n    background-color: var(--color-primary);\n    background-image: none;\n    background-repeat: no-repeat;\n    text-decoration: none;\n}\n\n.dropdownMenu .indent {\n    margin-left: 14px;\n}\n\n.dropdownMenu .checkmark {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    padding: 0 4px;\n    margin-top: -6px;\n}\n\n.dropdownIcon {\n    display: inline-block;\n}\n\n.dropdownIconPiece {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n    min-width: 10px;\n    line-height: 0;\n}\n\n.dropdownInput {\n    display: flex;\n    width: 100%;\n}\n\n.dropdownInput input {\n    border: none;\n    width: 100%;\n    padding: 0;\n}\n\n.highlightedText {\n    text-decoration: underline;\n}\n\n.itemDescription {\n    margin-left: 16px;\n    font-style: italic;\n}\n\n.error {\n    outline: 2px solid var(--color-red-dark-1);\n    outline-offset: -1px;\n}\n\n.itemOverflowContainer {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullDropdown": `Dropdown_fullDropdown__6LYLC`,
	"disabled": `Dropdown_disabled__x-MEQ`,
	"disabledItem": `Dropdown_disabledItem__WCifc`,
	"fullDropdownToggle": `Dropdown_fullDropdownToggle__AelQ5`,
	"fullDropdownIcon": `Dropdown_fullDropdownIcon__YvaBm`,
	"dropdown": `Dropdown_dropdown__ioXBM`,
	"dropdownToggle": `Dropdown_dropdownToggle__t8jni`,
	"dropdownMenu": `Dropdown_dropdownMenu__OC6Uw`,
	"open": `Dropdown_open__9YFXq`,
	"divider": `Dropdown_divider__uMAti`,
	"dataDiv": `Dropdown_dataDiv__Qp8Xc`,
	"active": `Dropdown_active__TP6Xj`,
	"indent": `Dropdown_indent__tTYBn`,
	"checkmark": `Dropdown_checkmark__QChGb`,
	"dropdownIcon": `Dropdown_dropdownIcon__gxUNe`,
	"dropdownIconPiece": `Dropdown_dropdownIconPiece__eR5dU`,
	"dropdownInput": `Dropdown_dropdownInput__dGygC`,
	"highlightedText": `Dropdown_highlightedText__eWmbw`,
	"itemDescription": `Dropdown_itemDescription__fMbY6`,
	"error": `Dropdown_error__k9ivW`,
	"itemOverflowContainer": `Dropdown_itemOverflowContainer__of7oZ`
};
export default ___CSS_LOADER_EXPORT___;
